import { Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import {
  Data,
} from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject } from 'rxjs';
import {
  AverageTransactionValue,
} from '../../../../model/average-transaction-value';
import { IAverageTransactionValueApiService } from './average-transaction-value-api.interface';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { ExportAvgTransactionValueQueryDto } from './dtos/export-avg-transaction-value.query.dto';
import { FindAvgTransactionValueQueryDto } from './dtos/find-avg-transaction-value.query.dto';
import { FindAvgTransactionValueResponseDto } from './dtos/find-avg-transaction-value.response.dto';

@Injectable({
  providedIn: 'root',
})
export class AverageOrderValuesMockApiService
  implements IAverageTransactionValueApiService
{
  data = {
    average_order_values: {
      items: [] as AverageTransactionValue[],
      queryOptions: {
        page: 1,
        size: 10,
      } as QueryOptions<AverageTransactionValue>,
      subject: new BehaviorSubject<Maybe<AverageTransactionValue[]>>(null),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get averageOrderValuesData() {
    return this.data['average_order_values'] as Data<
      AverageTransactionValue,
      AverageTransactionValue
    >;
  }

  findAverageTransactionValue(query: FindAvgTransactionValueQueryDto): Promise<FindAvgTransactionValueResponseDto> {
    throw new Error('Method not implemented.');
  }
  exportAverageTransactionValue(query: ExportAvgTransactionValueQueryDto, options?: HandleBlobHttpResponseOptions): void {
    throw new Error('Method not implemented.');
  }
}
